/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_2_Item_Cookies_DescInputs */

const en_privacy_section_2_item_cookies_desc = /** @type {(inputs: Privacy_Section_2_Item_Cookies_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`your choice to accept or decline analytics cookies, stored locally in your browser`)
};

const lv_privacy_section_2_item_cookies_desc = /** @type {(inputs: Privacy_Section_2_Item_Cookies_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsu izvēle pieņemt vai noraidīt analītikas sīkdatnes, kas glabājas lokāli Jūsu pārlūkā`)
};

/**
* | output |
* | --- |
* | "your choice to accept or decline analytics cookies, stored locally in your browser" |
*
* @param {Privacy_Section_2_Item_Cookies_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_2_item_cookies_desc = /** @type {((inputs?: Privacy_Section_2_Item_Cookies_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_2_Item_Cookies_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_2_item_cookies_desc(inputs)
	return en_privacy_section_2_item_cookies_desc(inputs)
});